<template>
    <a-modal v-model="visible" title="" width="750px" @cancel="close" :maskClosable="!loading" :footer="null">
        <h4 class="font-weight-bolder text-left kova-text">Skills Assessment Exercise</h4>
        <p class="text-left" :class="{ 'text-danger font-weight-bold': error }">
            Pick one of the skills below for assessment
        </p>

        <div class="row px-4 skills">
            <div
                class="col-sm-12 text-center col-md-4 my-3 bg-white border add-h skill p-3"
                :key="skill"
                v-for="skill in profile.skills"
                @click="language = skill"
                :class="{ chosen: language === skill }"
            >
                <img class="mt-3" :src="getSkillImg(skill)" />
                <p>{{ skill }}</p>
            </div>
        </div>

        <div class="text-right mt-3">
            <button
                style="border-radius: 10px;"
                class="p-2 px-md-4 px-lg-5 font-weight-bolder request btn-kovatek"
                @click="submit"
            >
                {{ loading ? 'Submitting...' : 'Submit' }}
            </button>
        </div>
    </a-modal>
</template>

<script>
export default {
    props: {
        visible: Boolean,
        profile: Object,
    },
    computed: {
        testName() {
            return `${this.language} Test`;
        },
    },
    data() {
        return {
            loading: false,
            error: false,
            language: null,
        };
    },
    methods: {
        submit() {
            const { complexity } = this.profile;
            if (!this.language) return this.showError('', 'Pick one of the skills below for assessment');

            this.error = false;

            this.startExercise({
                name: this.testName,
                language: this.language.toLowerCase(),
                // language: 'Vue',
                complexity,
                type: 1,
            });
        },
        async startExercise(data) {
            this.loading = true;
            const token = localStorage.getItem('token');
            try {
                const res = await this.$api({
                    url: `/tests`,
                    method: 'post',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    data,
                });
                this.loading = false;
                this.close();
                this.$emit('done', res.data);
            } catch (err) {
                this.loading = false;
                this.catchErrors(err);
                // console.log(err)
            }
        },
        close() {
            this.$emit('update:visible', false);
        },
    },
};
</script>

<style scoped>
.error {
    color: #fc0404;
    text-align: left;
}

.skills {
    max-height: 500px;
    overflow: hidden;
    overflow-y: auto;
    border-top: 1px solid #f5f5f5;
    border-bottom: 1px solid #f5f5f5;
}

.skill img {
    height: 45px;
}

.skill.chosen,
.skill:hover {
    border-radius: 5px;
    cursor: pointer;
    font-size: 20px;
    transform: scale(1.15);
}

.skill.chosen {
    background-color: #20409a !important;
    z-index: 9;
    color: #ffffff;
}

.skill:hover {
    border: 2px solid #20409a;
}

.skills::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #20409a;
    background-color: #ffffff;
    border-radius: 10px;
}

.skills::-webkit-scrollbar {
    width: 10px;
    background-color: #ffffff;
}

.skills::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px #20409a;
    background-color: #20409a;
}

.ant-modal {
    margin-top: -20px;
}
</style>
